var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "95%" } },
    [
      _vm.loading
        ? [_c("Loader", { attrs: { delay: 0 } })]
        : [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "IRC En Servicio" }
                          },
                          [
                            _c("b-form-select", {
                              staticClass: "mb-3",
                              attrs: {
                                options: _vm.irc_servicio_options,
                                "text-field": "tipo",
                                "value-field": "tipo",
                                disabled: !_vm.hasPermision("E")
                              },
                              model: {
                                value: _vm.info.irc_en_servicio,
                                callback: function($$v) {
                                  _vm.$set(_vm.info, "irc_en_servicio", $$v)
                                },
                                expression: "info.irc_en_servicio"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Uso IRC" }
                          },
                          [
                            _c("b-form-select", {
                              staticClass: "mb-3",
                              attrs: {
                                options: _vm.irc_uso_options,
                                "text-field": "tipo",
                                "value-field": "tipo",
                                disabled: !_vm.hasPermision("E")
                              },
                              model: {
                                value: _vm.info.uso_irc,
                                callback: function($$v) {
                                  _vm.$set(_vm.info, "uso_irc", $$v)
                                },
                                expression: "info.uso_irc"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Ubicación sala caldera" }
                          },
                          [
                            _c("b-form-select", {
                              staticClass: "mb-3",
                              attrs: {
                                options: _vm.ubicacion_options,
                                "text-field": "ubicacion_sala_caldera",
                                "value-field": "ubicacion_sala_caldera",
                                disabled: !_vm.hasPermision("E")
                              },
                              model: {
                                value: _vm.info.ubicacion_sala_caldera,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.info,
                                    "ubicacion_sala_caldera",
                                    $$v
                                  )
                                },
                                expression: "info.ubicacion_sala_caldera"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Régimen vivienda finca" }
                          },
                          [
                            _c("b-form-select", {
                              staticClass: "mb-3",
                              attrs: {
                                options: _vm.regimen_options,
                                "text-field": "tipo",
                                "value-field": "tipo",
                                disabled: !_vm.hasPermision("E")
                              },
                              model: {
                                value: _vm.info.regimen_vivienda_finca,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.info,
                                    "regimen_vivienda_finca",
                                    $$v
                                  )
                                },
                                expression: "info.regimen_vivienda_finca"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Columna anillo" }
                          },
                          [
                            _c("b-form-select", {
                              staticClass: "mb-3",
                              attrs: {
                                options: _vm.columna_options,
                                "text-field": "columna_anillo",
                                "value-field": "columna_anillo",
                                disabled: !_vm.hasPermision("E")
                              },
                              model: {
                                value: _vm.info.columna_anillo,
                                callback: function($$v) {
                                  _vm.$set(_vm.info, "columna_anillo", $$v)
                                },
                                expression: "info.columna_anillo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Tubular" }
                          },
                          [
                            _c("b-form-select", {
                              staticClass: "mb-3",
                              attrs: {
                                options: _vm.tubular_options,
                                disabled: !_vm.hasPermision("E")
                              },
                              model: {
                                value: _vm.info.monotubular_bitubular,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.info,
                                    "monotubular_bitubular",
                                    $$v
                                  )
                                },
                                expression: "info.monotubular_bitubular"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Sala descentralizada" }
                          },
                          [
                            _c("b-form-select", {
                              staticClass: "mb-3",
                              attrs: {
                                options: _vm.sala_options,
                                "text-field": "tipo",
                                "value-field": "tipo",
                                disabled: !_vm.hasPermision("E")
                              },
                              model: {
                                value: _vm.info.sala_descentralizada,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.info,
                                    "sala_descentralizada",
                                    $$v
                                  )
                                },
                                expression: "info.sala_descentralizada"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Año instalación caldera" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: !_vm.hasPermision("E") },
                              model: {
                                value: _vm.info.antiguedad_caldera,
                                callback: function($$v) {
                                  _vm.$set(_vm.info, "antiguedad_caldera", $$v)
                                },
                                expression: "info.antiguedad_caldera"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Num. tanques" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: !_vm.hasPermision("E") },
                              model: {
                                value: _vm.info.nro_tanques,
                                callback: function($$v) {
                                  _vm.$set(_vm.info, "nro_tanques", $$v)
                                },
                                expression: "info.nro_tanques"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Capacidad depósito" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: !_vm.hasPermision("E") },
                              model: {
                                value: _vm.info.capacidad_deposito,
                                callback: function($$v) {
                                  _vm.$set(_vm.info, "capacidad_deposito", $$v)
                                },
                                expression: "info.capacidad_deposito"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Mantenedor caldera" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: !_vm.hasPermision("E") },
                              model: {
                                value: _vm.info.mantenedor_caldera,
                                callback: function($$v) {
                                  _vm.$set(_vm.info, "mantenedor_caldera", $$v)
                                },
                                expression: "info.mantenedor_caldera"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: {
                              label: "Suministrador combustible caldera"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: !_vm.hasPermision("E") },
                              model: {
                                value:
                                  _vm.info.suministrador_combustible_caldera,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.info,
                                    "suministrador_combustible_caldera",
                                    $$v
                                  )
                                },
                                expression:
                                  "info.suministrador_combustible_caldera"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _vm.hasPermision("E")
                  ? _c(
                      "b-col",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c("b-button", { on: { click: _vm.cancel } }, [
                          _vm._v("Cancelar")
                        ]),
                        _vm._v(" "),
                        _c("b-button", { on: { click: _vm.save } }, [
                          _vm._v("Guardar")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/Details/info_adicional.vue?vue&type=template&id=ccf54306&
// module id = null
// module chunks = 